import { useMutation } from '@tanstack/react-query';
import ApiRoutes from 'src/constants/ApiRoutes';
import { useToast } from '@get-mosh/msh-shared';
import { getHeaders } from 'src/services/api';
import { ApiError } from 'src/types/Api';
import { ContactPreferencesRequest } from './types';

export async function updateContactPreferences(
    request: ContactPreferencesRequest,
): Promise<void> {
    const res = await fetch(ApiRoutes.UPDATE_USER_CONTACT_PREFERENCES, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(request),
    });

    const data = await res.json();
    if (!res.ok) {
        throw data as ApiError;
    }
}

export const useUpdateContactPreferences = () => {
    const { showToast } = useToast();

    return useMutation<void, ApiError, ContactPreferencesRequest>({
        mutationKey: ['UserContactPreferences'],
        mutationFn: (request: ContactPreferencesRequest) =>
            updateContactPreferences(request),
        onError: () => {
            showToast({
                title: 'An error occurred',
                message: 'Please try again later',
                variant: 'error',
            });
        },
    });
};
